import { LOGIN, FORGOT_PASSWORD, CHANGE_PASSWORD } from '../actions';

export const ERROR_TEXTS = {
    [LOGIN.FAILED]: 'invalid user credentials',
    [FORGOT_PASSWORD.FAILED]: 'invalid email',
    [CHANGE_PASSWORD.FAILED]: 'wrong password'
};

export const ARE_YOU_SURE_TEXT = 'You have unsaved changes, are you sure you want to leave?';



// WEBPACK FOOTER //
// ./src/constants/texts/errors.js